import request from '@/utils/request'

/**
 * 填充交管填写的信息
 * @param firstHand
 * @return {*}
 */
export function fillFirstHand (firstHand) {
    return request({
        url:`/api/FirstHand/fill-firstHand`,
        method:'post',
        data: firstHand
    })
}

/**
 * 根据流程ID 查询信息
 * @param flowId
 * @return {*}
 */
export function findFirstHandByFlowId(flowId){
    return request({
        url: `api/FirstHand/find-firstHand-byFlowId?flowId=${flowId}`,
        method: "get"
    })
}

export function updateState(flowId,state){
    return request({
        url: `api/FirstHand/update-state?flowId=${flowId}&state=${state}`,
        method: "get"
    })
}

/**
 * 根据工号查询待审批
 * @param empNo
 * @return {AxiosPromise}
 */
export function firstHandAgency(empNo){
    return request({
        url: `/api/FirstHand/first-hand-agency?empNo=${empNo}`,
        method: "get"
    })
}